<template>
  <b-dropdown
    class="select-target"
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    toggle-class="rounded-pill flex-center justify-content-between"
  >
    <template slot="button-content">
      <div class="text-truncate button-content" :title="selectedName" v-no-capture>
        {{ selectedName }}
      </div>
    </template>
    <b-dropdown-item @click="$emit('change', orgItem)" v-if="showOrgGroup" v-no-capture
      >{{ orgItem.name }}
    </b-dropdown-item>
    <b-dropdown-divider v-if="showOrgGroup && teams.length > 0" />
    <b-dropdown-group header="Teams" v-if="teams.length > 0">
      <b-dropdown-item v-for="team in teams" @click="$emit('change', team)" :key="team.id">
        <span :title="team.name" v-no-capture>{{ team.name }}</span>
      </b-dropdown-item>
    </b-dropdown-group>
    <b-dropdown-text class="pl-2" v-if="!showOrgGroup && teams.length === 0">
      Nothing here
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import { ENTITY_TYPE } from '@/constants/entities'

/**
 * This component shows a dropdown containing org(from orgItem prop) and list of Teams
 * @emits
 * - change: emitted when dropdown item is selected
 */
import {
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BDropdownGroup,
  BDropdownText
} from 'bootstrap-vue'

export default {
  name: 'OrgTeamDropdown',
  props: {
    selected: { default: () => ({}) },
    parentTeamId: Number,
    showOrgGroup: Boolean,
    orgItem: Object,
    /*
      Possible values = ENTITY_TYPE.GOAL, ENTITY_TYPE.PROJECT, null
      This tell the context in which dropdown is opened.
      entityContext == ENTITY_TYPE.GOAL:  Show only those team for which Goals feature is enabled
      entityContext == ENTITY_TYPE.PROJECT:  Show only those team for which Projects feature is enabled
      !entityContext === true:  Show all teams
     */
    entityContext: String
  },
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownGroup,
    BDropdownText
  },
  computed: {
    teams() {
      return this.$store.getters.user.teams.filter(
        team =>
          team.parentId === this.parentTeamId &&
          !team.isArchived &&
          !team.isOrgLike &&
          this.satisfyEntityContext(team)
      )
    },
    selectedName() {
      // when org is changed, update selected value of team dropdown to "Org Goals"
      return this.selected.isOrgLike ? this.orgItem.name : this.selected.name
    }
  },
  methods: {
    satisfyEntityContext(team) {
      if (!this.entityContext) return true
      else if (this.entityContext === ENTITY_TYPE.GOAL) return team.preferences.enableGoals
      else if (this.entityContext === ENTITY_TYPE.PROJECT) return team.preferences.enableProjects
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$dropdown-width: 165px;

/deep/ button {
  text-align: left;
  border-color: $borderPrimary;
}

/deep/ .button-content {
  width: $dropdown-width;
}

/deep/ .dropdown-menu {
  left: 14px !important;
  min-width: $dropdown-width;
}

/deep/ .dropdown-item {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/deep/ .dropdown-header {
  color: $brand;
  font-weight: 600;
}
</style>
